export default __webpack_public_path__ + "static/7-value-91ac536c05c51f7c551ea6aa8bcf9c21.png";